// Copyright (c) 2017 Deere & Company

import {Link} from 'react-router';
import React from 'react';

const baseAPI = '/reimbursement-summary/claims';

export const getClaimSummaryHeader = params => {

    const endQueryString = `postingDateFrom=${params.postingDateFrom}&postingDateTo=${params.postingDateTo}&leadAccountDisplayName=${encodeURIComponent(params.leadAccountDisplayName)}`;

    const summary = [
        {
            displayValue: decodeURIComponent(params.leadAccountDisplayName),
            queryString: null
        }
    ];

    if (params.city) {

        summary[0].queryString = `leadAccount=${params.leadAccount}`;
        summary.push({
            displayValue: params.city,
            queryString: null
        });

    }

    if (params.account) {

        summary[0].queryString = `leadAccount=${params.leadAccount}&city=${params.city}`;
        summary.push({
            displayValue: params.account,
            queryString: null
        });

    }

    return summary.map((element, index) =>
        <span
            className='bread-crumb'
            key={index}
        >
            {element.queryString ?
                <Link
                    to={`${baseAPI}?${element.queryString}&${endQueryString}`}
                >
                    {element.displayValue}
                </Link> :
                    element.displayValue
                }
        </span>
    );

};



// WEBPACK FOOTER //
// ./src/reimbursement-summary/claims/components/claim-summary-header.js